import {
  AggregationType,
  ChartType,
} from '@/features/charts/components/create-chart-type-selection';
import { supabase } from '@/lib/supabase';
import { KpiWithMetrics } from '@/shared/types/api';

export interface CreateChartData {
  chartType: ChartType;
  aggregationType: AggregationType;
  kpis: KpiWithMetrics[];
}

export const createChart = async ({
  chartData,
  userId,
  orgaId,
  projectId,
  isDerivative,
}: {
  chartData: CreateChartData;
  userId: string;
  orgaId: number;
  projectId: number;
  isDerivative: boolean;
}): Promise<void> => {
  const { error } = await supabase.rpc('create_chart_config', {
    p_chart_type: chartData.chartType ?? '',
    p_aggregation_type: chartData.aggregationType,
    p_config_type: chartData.chartType ?? '',
    p_created_by: userId,
    p_creator_orga_id: orgaId,
    p_project_id: projectId,
    p_kpi_ids: chartData.kpis.map((kpi) => kpi.id),
    p_is_derivative: isDerivative,
  });

  if (error) {
    throw error;
  }

  return;
};
